import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../services/auth-service/auth.service';
import { filter, map, Observable, of, take } from 'rxjs';
import { COMPANY_CONFIGURATION_FACADE } from '../../services/facades';
import { BasicDataResult } from '../../services/data-orchestrator';
import { CompanyConfigurationDto } from 'src/app/shared/models';

interface TrustPilotOptions {
  isTrustpilotVisible: boolean;
  trustpilotLanguage?: string;
}

// TODO - Hybrid App - This resolver should be removed
@Injectable({
  providedIn: 'root',
})
export class TrustpilotVisibilityResolver {
  private readonly authService = inject(AuthService);
  private readonly companyConfigurationFacade = inject(COMPANY_CONFIGURATION_FACADE);

  resolve(): Observable<TrustPilotOptions> {
    const loggedInUser = this.authService.getLoggedInUser();

    if (loggedInUser) {
      const { data$ } = this.companyConfigurationFacade.getCompanyConfiguration({
        companyId: loggedInUser.CompanyId,
        readFromCacheFirst: true,
        disableAutoRefresh: false,
        writeToCache: true,
      });

      return data$.pipe(
        filter((result: BasicDataResult<CompanyConfigurationDto>) => !result.loading),
        take(1),
        map((result: BasicDataResult<CompanyConfigurationDto>) => {
          if (result.error) {
            return { isTrustpilotVisible: false };
          }

          return {
            isTrustpilotVisible: result.data.IsTrustPilotVisible,
            trustpilotLanguage: result.data.TrustPilotLanguage,
          };
        }),
      );
    }

    return of({ isTrustpilotVisible: false });
  }
}
